import React, { Component } from 'react';
import {
    Grid, Row, Col,
    FormGroup, ControlLabel, FormControl
} from 'react-bootstrap';
import { connect } from 'react-redux'
import Card from 'components/Card/Card.jsx';

import Button from 'elements/CustomButton/CustomButton.jsx';
import Checkbox from 'elements/CustomCheckbox/CustomCheckbox.jsx';

import { firebaseAuthentication } from '../../authentication'
import api from '../../services/index'
import { adminAction } from '../../actions'
import SweetAlert from 'react-bootstrap-sweetalert';

class LoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardHidden: true,
            email: null,
            password: null,
            secret: null,
            alert: null
        }
        this.login = this.login.bind(this)
        this.hideAlert = this.hideAlert.bind(this);
    }
    async componentWillMount() {
        const isLogin = await firebaseAuthentication.authenticated
        if (isLogin) this.props.history.push("/dashboard")
    }
    hideAlert() {
        this.setState({
            alert: null
        });
    }
    async login(event) {
        event.preventDefault();
        try {
            await firebaseAuthentication.signInWithEmailAndPassword(this.state.email.value, this.state.password.value)
            const firebaseToken = await firebaseAuthentication.getIdToken()
            const result = await api.superAdmin.login(firebaseToken)
            console.log("result: ", result)
            this.props.dispatch(adminAction.login({ firebaseToken: firebaseToken, superToken: result.superToken }))
            // await firebaseAuthentication.authenticated
            this.props.history.push("/dashboard")
        } catch (err) {
            this.setState({
                alert: (
                    <SweetAlert
                        style={{ display: "block", marginTop: "-100px" }}
                        title="Thất bại"
                        onConfirm={() => this.hideAlert()}
                        onCancel={() => this.hideAlert()}
                        confirmBtnBsStyle="info"
                    >
                        Đăng nhập thất bại
                    </SweetAlert>
                )
            });
        }
    }
    componentDidMount() {
        setTimeout(function () { this.setState({ cardHidden: false }); }.bind(this), 700);
    }
    render() {
        return (
            <Grid>
                {this.state.alert}
                <Row>
                    <Col md={4} sm={6} mdOffset={4} smOffset={3}>
                        <form onSubmit={this.login}>
                            <Card
                                hidden={this.state.cardHidden}
                                textCenter
                                title="Login"
                                content={
                                    <div>
                                        <FormGroup>
                                            <ControlLabel>
                                                Email address
                                            </ControlLabel>
                                            <FormControl
                                                placeholder="Enter email"
                                                type="email"
                                                inputRef={ref => { this.state.email = ref; }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <ControlLabel>
                                                Password
                                            </ControlLabel>
                                            <FormControl
                                                placeholder="Password"
                                                type="password"
                                                inputRef={ref => { this.state.password = ref; }}
                                            />
                                        </FormGroup>
                                        {/* <FormGroup>
                                            <ControlLabel>
                                                Secret
                                            </ControlLabel>
                                            <FormControl
                                                placeholder="Secret"
                                                type="password"
                                                inputRef={ref => { this.state.secret = ref; }}
                                            />
                                        </FormGroup> */}
                                    </div>
                                }
                                legend={
                                    <Button bsStyle="info" fill wd onClick={this.login}>
                                        Login
                                    </Button>
                                }
                                ftTextCenter
                            />
                        </form>
                    </Col>
                </Row>
            </Grid>
        );
    }
}


const mapStateToProps = (state) => {
    return state;
};

export default connect(mapStateToProps)(LoginPage);





// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx